import { ReasonCategoryEnum } from "@gtpl/shared-models/common-models";

export class ReasonCategoryDto{
    category:ReasonCategoryEnum

    constructor(category:ReasonCategoryEnum){
        this.category = category
    }
}